<div class="container">
  <div class="row" *ngIf="isLoggedIn && isReady">
    <div class="col p-2">
      <span style="margin-top: 50px">Zeige alle <a [routerLink]="['/courses']"> Lehrgänge </a> oder <a
        class="ui-link"  (click)="newCourseSelection()"> neuen Lehrgang </a> anlegen.</span>


      <div class="card mt-2">
        <div class="card-header">
          Meine Lehrgänge:
          <span class="right" *ngIf="!dataLoaded.courseStatistics">loading
            <fa-icon [icon]="faSyncAlt" [spin]="true"></fa-icon>
          </span>
        </div>
        <div class="card-body">
          <ul class="list-group">
            <li class="list-group-item">
              <span class="badge badge-info">{{ statistics.course.draft}}</span> in Bearbeitung
            </li>
            <li class="list-group-item">
              <span class="badge badge-warning">{{ statistics.course.review}}</span> in Prüfung
            </li>
            <li class="list-group-item">
              <span class="badge badge-success">{{ statistics.course.published}}</span> veröffentlicht
            </li>
            <li class="list-group-item">
              <span class="badge badge-danger">{{ statistics.course.rejected}}</span> abgelehnt
            </li>
          </ul>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-header">
          letzte Kommentare:
          <span class="right" *ngIf="!dataLoaded.courseComments">loading
            <fa-icon [icon]="faSyncAlt" [spin]="true"></fa-icon>
          </span>
        </div>
        <div class="card-body">
          <app-comments-view [comments]="comments.course" paragraphClass="card-text"></app-comments-view>
        </div>
      </div>
    </div>
    <div class="col p-2 invisible">
      <span style="margin-top: 50px">Zeige alle <a [routerLink]="['/competitions']"> Wettkämpfe </a> oder <a
          [routerLink]="['/competitions/edit/0', {type:'competition', form:1}]"> neuen Wettkampf </a> anlegen.</span>
      <div class="card mt-2">
        <div class="card-header">
          Meine Wettkämpfe:
          <span class="right" *ngIf="!dataLoaded.competitionStatistics">loading
            <fa-icon [icon]="faSyncAlt" [spin]="true"></fa-icon>
          </span>
        </div>
        <div class="card-body">
          <ul class="list-group">
            <li class="list-group-item">
              <span class="badge badge-info">{{ statistics.competition.draft}}</span> in Bearbeitung
            </li>
            <li class="list-group-item">
              <span class="badge badge-warning">{{ statistics.competition.review}}</span> in Prüfung
            </li>
            <li class="list-group-item">
              <span class="badge badge-success">{{ statistics.competition.published}}</span> veröffentlicht
            </li>
            <li class="list-group-item">
              <span class="badge badge-danger">{{ statistics.competition.rejected}}</span> abgelehnt
            </li>
          </ul>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-header">
          letzte Kommentare:
          <span class="right" *ngIf="!dataLoaded.competitionComments">loading
            <fa-icon [icon]="faSyncAlt" [spin]="true"></fa-icon>
          </span>
        </div>
        <div class="card-body">
          <!-- <p class="card-text" *ngFor="let item of comments.course">{{item}}</p> -->
          <!-- <p class="card-text">Das ist noch ein anderer Kommentar.</p>
          <a href="#" class="btn btn-primary">Go somewhere</a> -->
        </div>
      </div>
    </div>
    <div class="row m-auto" *ngIf="!isLoggedIn || !isReady">
      <h2>Einen Moment bitte ...</h2>
    </div>
  </div>
